export default __webpack_public_path__ + "static/media/nft-example-1.bd42fabd.jpg";